import builder from '../builder';
import ToiletSeat from '../../streamline-icons/bold/toilet-seat.svg';

export default builder('IconToiletSeatBold', ToiletSeat);
